/* eslint-disable css-modules/no-unused-class, no-nested-ternary */

import { FC, useEffect, useRef, useState } from 'react';
import { Icon } from 'learning-panel-components';
import UserSection from './userSection';
import styles from './leanTopRightSection.module.scss';
import topBarStyles from './topBar.module.scss';
import { KeyboardArrowDownIcon } from '../../../uiLibraryImports';
import Leaderboard from '../../play/leaderboard/userLeaderboard/leaderboard';

const LeanTopRightSection: FC<LeanTopRightSectionProps> = (props: LeanTopRightSectionProps) => {
    const {
        imageSrc,
        userName,
        onLogout,
        setIsAccountSettingsOpen,
        setIsContactSupportOpen,
        narrowScreen,
        devCoins,
        userRank,
        isPLG
    } = props;

    const [showLeaderboard, setShowLeaderboard] = useState<boolean>(false);
    const leaderboardButtonRef = useRef() as React.MutableRefObject<HTMLInputElement>;
    const leaderboardWrapperRef = useRef() as React.MutableRefObject<HTMLInputElement>;

    useEffect(() => {
        const checkIfClickedOutside = (e: any) => {
            if (
                showLeaderboard &&
                leaderboardButtonRef.current &&
                !leaderboardButtonRef.current.contains(e.target) &&
                !leaderboardWrapperRef.current.contains(e.target)
            ) {
                setShowLeaderboard(false);
            }
        };

        document.addEventListener('mousedown', checkIfClickedOutside);

        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [showLeaderboard]);

    return (
        <div className={styles['lean-top-right-section']}>
            {!isPLG && (
                <div
                    className={styles['leaderboard-btn-wrapper']}
                    ref={leaderboardButtonRef}
                    onClick={() => setShowLeaderboard(!showLeaderboard)}
                >
                    <div className={styles['bar-chart-icon-wrapper']}>
                        <Icon name="barChart" />
                    </div>
                    <div className={styles['user-rank']}>{userRank !== 0 && `#${userRank}`}</div>
                    <KeyboardArrowDownIcon />
                </div>
            )}
            {showLeaderboard && (
                <div className={styles['leaderboard-wrapper']} ref={leaderboardWrapperRef}>
                    <Leaderboard onClose={() => setShowLeaderboard(false)} onlyUsers />
                    <div
                        className={styles['top-background']}
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/rightExpandTop.svg)` }}
                    />
                    <div
                        className={styles['bottom-background']}
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL}/images/rightExpandBottom.svg)`
                        }}
                    />
                </div>
            )}
            <div className={topBarStyles.divider} />
            <div className={styles['dev-coin-icon-wrapper']}>
                <Icon name="devCoin" />
            </div>
            <div className={styles['dev-coins']}>{devCoins.toLocaleString()}</div>
            <div className={topBarStyles.divider} />
            <UserSection
                imageSrc={imageSrc}
                userName={userName}
                onLogout={onLogout}
                setIsAccountSettingsOpen={setIsAccountSettingsOpen}
                setIsContactSupportOpen={setIsContactSupportOpen}
                narrowScreen={narrowScreen}
            />
        </div>
    );
};

interface LeanTopRightSectionProps {
    imageSrc: string;
    userName: string;
    onLogout: Function;
    setIsAccountSettingsOpen: Function;
    setIsContactSupportOpen: Function;
    narrowScreen: boolean;
    devCoins: number;
    userRank: number;
    isPLG: boolean;
}

export default LeanTopRightSection;
